import React from 'react';
import { Box, Container, Flex, Heading, Button, Image, Text, Link, Center } from '@chakra-ui/react';
import SvgContactsCheckout from '../../assets/svg/SvgContactsCheckout';
import { FiPhone } from 'react-icons/fi';
import {ADDRESS, INSTAGRAM_LINK, PHONE_NUMBER_LINK, TELEGRAM_LINK, WHATSAPP_LINK, EMAIL_LINK } from '../../helpers/adminData';
import photo from '../../assets/img/formPhoto.webp';
import SvgLocationFooter from '../../assets/svg/SvgLocationFooter';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaTelegramPlane } from 'react-icons/fa';
import { AiFillInstagram } from 'react-icons/ai';
import { MdEmail } from 'react-icons/md';


const socialMedia = [
  {
    id: 1,
    icon: <IoLogoWhatsapp />,
    name: 'Whats App',
    color: '#1BC95C',
    link: WHATSAPP_LINK,
  },
  {
    id: 1,
    icon: <FaTelegramPlane />,
    name: 'Telegram',
    color: '#08A1E3',
    link: TELEGRAM_LINK,
  },
  {
    id: 1,
    icon: <AiFillInstagram />,
    name: 'Instagram',
    color: 'linear-gradient(213.52deg, #862D8E 14.36%, #E22072 56.46%, #EA794C 83.77%);',
    link: INSTAGRAM_LINK,
  },
 {
    id: 1,
    icon: <MdEmail />,
    name: 'Email',
    color: 'linear-gradient(213.52deg, #862D8E 14.36%, #E22072 56.46%, #EA794C 83.77%);',
    link: EMAIL_LINK,
  },

];
const Contacts = () => {
  return (
    <Box name='contacts' w='full'>
      <Container maxW='container.xl'>
        <Box p={{ base: '26px 27px 26px 27px', lg: '64px 118.91px 26px 200px' }}
             alignItems='center' justifyContent='space-between'
             w='full' bg='#393737' borderRadius='20px' flexDir={{ base: 'column', md: 'row' }}>
          <Heading textAlign={{ base: 'center', md: 'start' }} fontFamily='Raleway' fontWeight='700'
                   fontSize={{ base: '30px', md: '54px' }}
                   lineHeight={{ base: '45px', md: '63px' }} color='#ffffff'>Есть вопросы?</Heading>
          <Box display={{base:'block', md:'flex'}} alignItems={'center'} justifyContent={'space-between'}>
            <Flex flexDir='column' justifyContent={{ base: 'center', md: 'start' }}
                  alignItems={{ base: 'center', md: 'start' }}>
              <Heading fontSize='23px' color={'#fff'} mb={'15px'} mt={'15px'}>
                Соц.Сети
              </Heading>
              <Flex justifyContent='center' mb={'25px'}>
                {socialMedia.map(media => (
                  <Link href={media.link} target='_blank' mx={3} key={media.id}>
                    <Box bg={'#0000000D'} padding='10px' rounded='50%' cursor='pointer'>
                      <Flex justifyContent='center' alignItems='center' bg={media.color} rounded='50%'
                            width='48px' height='48px' fontSize='2rem' color='white'
                      >{media.icon}</Flex>
                    </Box>
                    <Text fontSize='12px' fontWeight='500' textAlign='center' color={'#fff'}>{media.name}</Text>
                  </Link>
                ))}
              </Flex>
              <Flex flexDirection={'column'}>
                <Heading fontSize='23px' color={'#fff'} mb={'15px'}>
                  График работы
                </Heading>
                <Text color={'#fff'}>ПН-СБ 09:00 - 18:00</Text>
              </Flex>
              <Center display={{base:"none",md:"flex"}} pt="60px" fontFamily='Raleway'
                      fontWeight="400" fontSize="12px" color="#ffffff">
                  <SvgLocationFooter/>
                  <Link href={`${ADDRESS}`} target='_blank'><Text opacity="0.5">г. К-Балта, Ул. Кожомбердиева-3</Text></Link>
              </Center>
            </Flex>
            <Box>
              <Image src={photo} />
              <Text textAlign={{ base: 'center', md: 'start' }} mt='22px' mb={{ base: '34px', md: '36px' }}
                    fontFamily='Gotham,sans-serif' fontWeight='400'
                    fontSize='20px' lineHeight='160%' color='#ffffff'>Свяжитесь с нами по номеру!</Text>
              <Center flexDir={{ base: 'column', md: 'row' }}>
                <Link href={WHATSAPP_LINK}>
                  <Button variant='none' border='1px solid #FFFFFF' borderRadius='70px' p='27px 18px'
                          leftIcon={<SvgContactsCheckout />} fontFamily='Raleway' fontWeight='600'
                          fontSize='16px' color='#ffffff'>Написать</Button></Link>
                <Link href={PHONE_NUMBER_LINK}>
                  <Button m={{ base: '34px 0 0 0', md: '0 0 0 34px' }} variant='none' border='1px solid #FFFFFF'
                          borderRadius='70px'
                          p='27px 18px'
                          leftIcon={<FiPhone fontSize='20px' />} fontFamily='Raleway' fontWeight='600'
                          fontSize='16px' color='#ffffff'>+996555866070</Button></Link>

              </Center>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Contacts;
